import { useObservation } from 'app/stores/dictionary/mobx/useObservation';
import $devices from '../../device/$devices';

const selector = () => $devices.uniqueSubtypes;
const conversion = (newValue: string[]) => new Set(newValue);

export const useDeviceUniqueSubtypes = (): Set<string> => useObservation(selector, conversion);
